import { render, staticRenderFns } from "./DataListListView.vue?vue&type=template&id=0be2d261"
import script from "./DataListListView.vue?vue&type=script&lang=js"
export * from "./DataListListView.vue?vue&type=script&lang=js"
import style0 from "./DataListListView.vue?vue&type=style&index=0&id=0be2d261&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports